<script lang="ts">
    // Types
    import { makeUserComponentsAction } from '@jet-app/music-classical/action-model/UserComponentsAction';

    // Component
    import AddToLibrary from '@amp/web-app-components/src/components/buttons/AddToLibrary.svelte';
    import FavoriteButton from '~/components/jet/buttons/FavoriteButton.svelte';

    // Utils
    import { getJetPerform } from '~/jet';
    import { getLocale } from '~/utils/locale';
    import { loggerFor } from '@amp/web-apps-logger';
    import { toggleFavorite } from '~/utils/favorites';

    // Stores
    import { getI18n } from '~/stores/i18n';
    import {
        subscribeToId,
        type LibraryStateValue,
    } from '~/stores/local-library-state';

    const ADD_PRODUCT_FLASH_TIMER = 5000;

    const i18n = getI18n();
    const locale = getLocale();
    const log = loggerFor('<CloudButtons>');
    const perform = getJetPerform();

    export let id: string;
    export let type: string;

    $: storefront = locale.storefront;
    $: sanitizedType = type.replace('-with-actions', '');
    $: enableAddToLibraryButton = ['album', 'playlist'].includes(sanitizedType);
    $: showFavoriteButton = ['artist', 'recording', 'work'].includes(
        sanitizedType,
    );
    $: showAddToLibraryButton = !libraryState?.inLibrary;

    let showAddingToLibrarySpinner: boolean = false;
    let showAddedToLibrary: boolean = false;
    let libraryState: LibraryStateValue;

    $: {
        subscribeToId(id, (value) => {
            libraryState = value;
            showAddingToLibrarySpinner = false;
        });
    }

    function handleToggleFavorite() {
        toggleFavorite(
            id,
            libraryState?.type,
            storefront,
            libraryState.inFavorites,
            perform,
        );
    }

    const handleAddClick = async () => {
        showAddingToLibrarySpinner = true;

        try {
            await perform(
                makeUserComponentsAction(
                    `/query/command/library/${storefront}`,
                    'perform',
                    {
                        id: id,
                        entityType: libraryState?.type,
                        inLibrary: !libraryState.inLibrary,
                    },
                ),
            );

            showAddedToLibrary = true;

            setTimeout(function () {
                showAddedToLibrary = false;
            }, ADD_PRODUCT_FLASH_TIMER);
        } catch (e) {
            log.error('Adding item to library failed:', e);
        } finally {
            showAddingToLibrarySpinner = false;
        }
    };
</script>

<div class="cloud-buttons" data-testid="cloud-buttons">
    {#if libraryState && showFavoriteButton}
        <FavoriteButton
            on:toggle={handleToggleFavorite}
            isFavorited={libraryState.inFavorites}
        />
    {/if}

    {#if libraryState && enableAddToLibraryButton}
        <AddToLibrary
            translateFn={$i18n.t}
            showSpinner={showAddingToLibrarySpinner}
            {showAddToLibraryButton}
            {showAddedToLibrary}
            iconOnly={false}
            on:addClick={handleAddClick}
        />
    {/if}
</div>
